import type { ReservedDatesClientInterface, StoreReservedDatePayload } from './reservedDatesClient.types';
import BaseClient from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class CorporateReservedDatesClient extends BaseClient implements ReservedDatesClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getReservedDates(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/reserved-dates`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getReservedDate(reservedDateId: number) {
        const url = `/api/v3/teams/${this.teamId}/reserved-dates/${reservedDateId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createReservedDate(data: StoreReservedDatePayload) {
        const url = `/api/v3/teams/${this.teamId}/reserved-dates`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateReservedDate(reservedDateId: number, data: StoreReservedDatePayload) {
        const url = `/api/v3/teams/${this.teamId}/reserved-dates/${reservedDateId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteReservedDate(reservedDateId: number) {
        const url = `/api/v3/teams/${this.teamId}/reserved-dates/${reservedDateId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}
